<template>
    <div>
        <div class="row">
            <div class="col-md-12">
            <div class="card fleet-table-card" :class="{ 'api-in-progress': apiInProgress }">
                <div class="card-header">
                    <div class="row">
                      <div class="text-search">
                      <fg-input
                          v-model="search"
                          size="mini"
                          addon-right-icon="nc-icon nc-zoom-split">
                      </fg-input>
                      </div>
                    </div>
                    <div class="row">
                        <div class="col-md-1"></div>
                        <div class="col-md-1">
                            <div class="row font-weight-bold">{{ $t( "myFleet.myFleet") }}</div>
                            <div class="row myFleet-number">{{contracts.length}}</div>
                            <div class="row">{{ $t( "myFleet.vehicles") }}</div>
                        </div>
                        <div class="col-md-8">
                            <div class="text-center spinner-container" v-if="!fleetData.loaded || apiInProgress">
                                <div class="spinner-border" role="status">
                                <span class="sr-only">{{ $t( "general.loading") }}</span>
                                </div>
                            </div>
                            <div class="" v-else>
                                <div>
                                  <el-radio-group v-model="filter" @change="filterChanged" class="fleet-filter-container" @click.native="filterChanged2" >
                                    <el-radio-button label="contractExpiring">
                                      <div class="row radio-button-up">{{contracts.filter(contract => contract.contractExpiring).length}}</div>
                                      <div class="row radio-button-down">{{ $t( "myFleet.contractExpiring") }}</div>
                                    </el-radio-button>
                                    <el-radio-button label="mileageMissing">
                                      <div class="row radio-button-up">{{contracts.filter(contract => contract.mileageMissing).length}}</div>
                                      <div class="row radio-button-down">{{ $t( "myFleet.missingMileageRead") }}</div>
                                    </el-radio-button>
                                    <el-radio-button label="ticketInProgress">
                                      <div class="row radio-button-up">{{contracts.filter(contract => contract.ticketInProgress).length}}</div>
                                      <div class="row radio-button-down">{{ $t( "myFleet.activeTickets") }}</div>
                                    </el-radio-button>
                                    <el-radio-button label="terms">
                                      <div class="row radio-button-up">{{contracts.reduce((sum, contract) => { if (contract.registrationExpiring || contract.insuranceExpiring || contract.kaskoExpiring) { return sum +1} else return sum }, 0) }}</div>
                                      <div class="row radio-button-down">{{ $t( "myFleet.closeTerms") }}</div>
                                    </el-radio-button>
                                  </el-radio-group>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2 action-buttons-col">
                            <p-button class="btn refresh-btn btn-round" type="info" @click="refreshData()">
                              <i class="fa fa-sync-alt"></i>
                            </p-button>
                            <p-button type="success" @click="downloadFleetXls()" class="btn  download-exel-button btn-round">
                              <i slot="label" class="fa fa-cloud-download-alt"></i> xlsx
                            </p-button>
                            <p-button class="add-ticket-btn-top" aria-label="add button" type="default" round  @click="openNewTicketModal(null)">{{ $t( "myFleet.newTicket") }}</p-button>
                        </div>
                    </div>
                </div>

                <div class="table-responsive table-full-width">
                 <el-table
                    v-if="fleetData.loaded"
                    class="table-expandable"
                    row-key="idFlat"
                    ref="tableFleet"
                    :expand-row-keys="contractSelected"
                    :data=filterSearch()
                    :row-class-name="tableRowClassName"
                    @row-click="rowClicked"
                    
                    style="width: 100%"
                    stripe >
                    <el-table-column type="expand" align="right">
                    <template slot-scope="props">
                      <div class="row fleet-expanded-row">

                        <div class="col-lg-5 col-sm-5">
                          <div class="fleet-driver">
                              <label class="col-md-12 col-form-label vehicle-driver-label">
                                  <i class="fa fa-user-tie"></i>
                                  <span class="card-subtitle mb-2 text-muted single-card">  {{ $t( "myFleet.vehicleDriver") }} </span>
                              </label>
                              <div class="col-md-12">
                                  <fg-input>
                                      <el-select class="select-default"
                                                  size="large"
                                                  filterable
                                                  :placeholder='$t( "myFleet.pick")'
                                                  :disabled="driverChangeInProgress"
                                                  :clearable="true"
                                                  :loading-text='$t( "myFleet.sendingRequest")'
                                                  v-model="props.row.korisnikId"
                                                  @change="onDriverChange(props.$index, $event)"
                                                  >
                                          <el-option v-for="option in contacts"
                                                  class="select-default"
                                                  :value="option._id"
                                                  :label="`${option.firstName} ${option.lastName}`"
                                                  :disabled="!!option.vehicleId"
                                                  :key="option._id">
                                                  <span style="float: left"><i class="fa fa-user"></i> {{ `${option.firstName} ${option.lastName}` }}</span>
                                                  <span style="float: right; color: #ef8157; font-size: 13px">{{ option.vehicleName  }}</span>
                                          </el-option>
                                      </el-select>
                                  </fg-input>
                              </div>
                          </div>
                          <div class="container">
                            <div class="vehicle-image-big">
                              <img :src="props.row.carPhoto || 'static/img/auto-silueta-osobno.png'">
                            </div>
                            <div><strong> UGOVOR </strong></div>
                            <div class="row fleet-contract-details text-center">
                              <div class="col-lg-3 col-sm-3">
                                <img src="static/img/icon-flota-ALLIN.png"/>
                              </div>
                              <div class="col-lg-3 col-sm-3">
                                <div class="fleet-contract-details-amount"><strong>{{props.row.ugpDuration}}</strong></div>
                                <div class="fleet-contract-details-description">{{ $t( "myFleet.contractDuration") }}</div>
                              </div>
                              <div class="col-lg-3 col-sm-3">
                                <div class="fleet-contract-details-amount"><strong>{{formatMileage(props.row.ugovorenaKilometraza)}}</strong></div>
                                <div class="fleet-contract-details-description">{{ $t( "myFleet.contractMileage") }}</div>
                              </div>
                              <div class="col-lg-3 col-sm-3">
                                <div class="fleet-contract-details-amount"><strong>{{formatMoney(props.row.monthlyAmount) || '-'}} {{props.row.monthlyAmountCurency}}</strong></div>
                                <div class="fleet-contract-details-description">{{ $t( "myFleet.contractMonthlyAmount") }}</div>
                              </div>

                            </div>
                          </div>
                        </div>
                        <div class="col-lg-2 col-sm-2">
                          <div class="fleet-card">
                            <div class="content row">
                              <div class="col-2">
                                  <div class="fleet-date-stick" :class="`fleet-date-stick-${daysLeftBeforeTerm(props.row)}`">

                                  </div>
                              </div>
                              <div class="col-10">
                                  <div class="content-deadlines text-left">
                                      <div class="row title small text-uppercase font-weight-bold">{{ $t( "myFleet.contractEnd") }}</div>
                                      <div class="row date"><strong>{{formatDatePlusLeftover(props.row)}}</strong></div>
                                  </div>
                              </div>
                              <hr class="w-100">
                            </div>
                            <div class="content row">
                              <div class="col-2">
                                  <div class="fleet-date-stick" :class="`fleet-date-stick-${daysLeftBeforeTerm(props.row, 'registrationEndDate_raw')}`">

                                  </div>
                              </div>
                              <div class="col-10 fleet-card-middle">
                                  <div class="content-deadlines text-left">
                                      <div class="row title small text-uppercase font-weight-bold">{{ $t( "myFleet.registrationEndDate") }}</div>
                                      <div class="row date"><strong>{{formatDatePlusLeftover(props.row, 'registrationEndDate_raw')}}</strong></div>
                                  </div>
                              </div>
                            </div>
                            <div class="content row">
                              <div class="col-2">
                                  <div class="fleet-date-stick" :class="`fleet-date-stick-${daysLeftBeforeTerm(props.row, 'istekOsig_raw')}`">

                                  </div>
                              </div>
                              <div class="col-10 fleet-card-middle">
                                  <div class="content-deadlines text-left">
                                      <div class="row title small text-uppercase font-weight-bold">{{ $t( "myFleet.insuranceEndDate") }}</div>
                                      <div class="row date"><strong>{{formatDatePlusLeftover(props.row, 'istekOsig_raw')}}</strong></div>
                                  </div>
                              </div>
                            </div>
                            <div class="content row">
                              <div class="col-2">
                                  <div class="fleet-date-stick" :class="`fleet-date-stick-${daysLeftBeforeTerm(props.row, 'istekOsigk_raw')}`">

                                  </div>
                              </div>
                              <div class="col-10 fleet-card-middle">
                                  <div class="content-deadlines text-left">
                                      <div class="row title small text-uppercase font-weight-bold">{{ $t( "myFleet.kaskoInsuranceEndDate") }}</div>
                                      <div class="row date"><strong>{{formatDatePlusLeftover(props.row, 'istekOsigk_raw')}}</strong></div>
                                  </div>
                              </div>
                            </div>
                            <hr class="w-100">
                            <div class="content row">
                              <div class="col-2">
                                <div class="content-icon text-left">
                                  <!-- <i class="action-icon nc-icon nc-refresh-69"></i> -->
                                </div>
                              </div>
                              <div class="col-10 fleet-card-middle">
                                  <div class="content-deadlines text-left">
                                      <div class="row title small text-uppercase font-weight-bold">{{ $t( "myFleet.lastDocumentedMileage") }}</div>
                                      <div class="row date">
                                        <strong>{{formatMileage(props.row.lastDocumentedMileage) || '-'}} km</strong>
                                      </div>
                                      <div class="row date">
                                        <span> ({{ $t( "myFleet.mileageReadFromDate") }} {{formatDate(props.row.lastDocumentedMileageDate)}})</span>
                                      </div>
                                  </div>
                              </div>
                            </div>
                            <p-button class="" aria-label="add button" type="default" round size="sm" @click="openNewMileageModal(props.row.id)">
                                {{ $t( "myFleet.update") }}
                            </p-button>
                          </div>
                        </div>
                        <div class="col-lg-5 col-sm-5  tickets-container">
                          <ul class="nav nav-tabs nav-tabs-vehicle text-uppercase">
                            <li class="nav-item nav-item-cases">
                              <a class="nav-link" @click.prevent="setActiveTicketsTab('activeCases')" :class="{ 'tickets-tab-active': isActiveTicketTab('activeCases') }" href="#activeCases">{{$t( "myFleet.activeCases")}}
                                <span class="badge">{{props.row.tickets.length}}</span>
                              </a>
                            </li>
                            <!--li class="nav-item nav-item-historycases">
                              <a class="nav-link" @click.prevent="setActiveTicketsTab('historyCases')" :class="{ 'tickets-tab-active': isActiveTicketTab('historyCases') }" href="#historyCases">{{$t( "myFleet.historyCases")}}</a>
                            </li-->
                            <li class="nav-item nav-item-events">
                              <a class="nav-link" @click.prevent="setActiveTicketsTab('vehicleEvents')" :class="{ 'tickets-tab-active': isActiveTicketTab('vehicleEvents') }" href="#vehicleEvents">{{$t( "myFleet.vehicleEvents")}}
                                <span class="badge">{{getUgpEventsHistory(props.row.ugpId).length}}</span>
                              </a>
                            </li>
                          </ul>
                          <div class="tab-content py-3 fleet-card2">

                            <!-- HD SLUČAJEVI -->
                            <div class="tab-pane" id="activeCases" v-if="isActiveTicketTab('activeCases')">
                              <div class="table-responsive fleet-tickets-table table-full-width">
                                <el-table :data="getTickets(props.row.tickets, true)">
                                    <el-table-column type="expand" align="right">
                                      <template slot-scope="scope">
                                        <div class="ticket-description">OPIS: {{scope.row.metadata.description}}</div>
                                        <div class="fleet-tickets-table-expanded">
                                          <ticket-activities :ticketId="scope.row._id" :flatEntityId="props.row.idFlat" :activities="scope.row.activities"></ticket-activities>
                                        </div>
                                      </template>
                                    </el-table-column>
                                    <el-table-column label="#" property="ticketNumber"></el-table-column>
                                    <el-table-column :label='$t( "myFleet.reportedDate")' property="created" :formatter="(r, c, val, i) => formatDate(val)"></el-table-column>
                                    <el-table-column :label='$t( "myFleet.ticketType")'   property="metadata.type" :formatter="(r, c, val, i) => $t(`ticketTypes.${val}`)"></el-table-column>
                                    <!--el-table-column :label='$t( "myFleet.reportedBy")'   property="metadata.reportedByName"></el-table-column-->
                                    <!-- <el-table-column :label='$t( "general.description")'  property="metadata.description"></el-table-column> -->
                                    <el-table-column :label='$t( "myFleet.status")'       property="metadata.status" class-name="fleet-tickets-table-badge">
                                        <template slot-scope="scope">
                                        <span class="ticket-status-badge" :class="`text-${statuses[scope.row.metadata.status].color}`" >{{statuses[scope.row.metadata.status].label}}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                              </div>
                            </div>

                            <!-- POVIJEST DOGAĐAJA NA VOZILU -->
                            <div class="tab-pane" id="vehicleEvents" v-if="isActiveTicketTab('vehicleEvents')">
                              <div class="table-responsive fleet-events-table table-full-width">
                                <el-table :data="getUgpEventsHistory(props.row.ugpId)">
                                  <el-table-column class="displaynone" label="#"  type="expand" ></el-table-column>
                                  <el-table-column label="#" width="50">
                                    <template slot-scope="props">
                                      {{props.$index + 1}}.
                                    </template>
                                  </el-table-column>
                                  <el-table-column  width="100" :label='$t( "myFleet.reportedDate")' property="date" :formatter="(r, c, val, i) => formatDate(val)"></el-table-column>
                                  <el-table-column :label='$t( "myFleet.eventName")' property="name">
                                    <template slot-scope="props">
                                      <span v-if="props.row.type === 'HD'">
                                        <b>HD</b> [SLUČAJ] {{ ticketTypes[props.row.name] }}
                                      </span>
                                      <span v-else-if="props.row.type === 'ZV'">
                                        <span class="icon zam-icon"></span>
                                        {{ props.row.name }}
                                      </span>
                                      <span v-else>
                                        <span v-if="props.row.expenseType === '5.1.1'" class="icon reg-icon"></span>
                                        <span v-if="props.row.expenseType === '6.1.1'" class="icon odrz-icon"></span>
                                        <span v-if="props.row.expenseType === '6.2.1'" class="icon odrz-icon"></span>
                                        <span v-if="props.row.expenseType === '6.3.1'" class="icon odrz-icon"></span>
                                        <span v-if="props.row.expenseType === '7.1.1'" class="icon upravljanje-stetama-icon"></span>
                                        <span v-if="props.row.expenseType === '7.1.2'" class="icon upravljanje-stetama-icon"></span>
                                        <span v-if="props.row.expenseType === '7.2.1'" class="icon upravljanje-stetama-icon"></span>
                                        <span v-if="props.row.expenseType === '8.1.1'" class="icon pneu-icon"></span>
                                        <span v-if="props.row.expenseType === '8.2.2'" class="icon pneu-icon"></span>
                                        {{ props.row.name }}
                                      </span>
                                      
                                    </template>
                                  </el-table-column>
                                </el-table>
                              </div>
                            </div>

                          </div>
                        </div>
                        
                        <p-button class="add-ticket-btn" aria-label="add button" type="default" round size="sm" @click="openNewTicketModal(props.row.id)">
                            <i class="nc-icon nc-single-copy-04"></i> {{ $t( "myFleet.newTicket") }}
                        </p-button>

                      </div>
                    </template>
                    </el-table-column>
                    <el-table-column
                      sortable
                      :class-name="setColumnClass('model')"
                      :sort-method="(a, b) => sortData(a, b, 'model')"
                      :label='$t( "myFleet.model")'
                      :formatter="(r, c, val, i) => `${i +1}) ${val}`"
                      prop="model">
                      <template slot-scope="scope">
                          <div class="row">
                              <div class="col-md-4 table-row-number">{{scope.$index + 1}})</div>
                              <div class="col-md-8">
                                <div class="row bold"><strong>{{scope.row.manufacturer}}</strong></div>
                                <div class="row">{{scope.row.modelAndManufacturer}}</div>
                              </div>
                          </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="vehicle-image">
                        <template slot-scope="scope">
                          <img :src="scope.row.carPhoto || 'static/img/auto-silueta-osobno.png'"/>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="filterSelected !== 'terms'"
                      sortable
                      :class-name="setColumnClass('sasija')"
                      align="center"
                      :sort-method="(a, b) => sortData(a, b, 'registrationTable')"
                      :label='$t( "myFleet.registrationPlates")'
                      prop="registrationTable">
                      <template slot-scope="scope">
                          <div>{{scope.row.registrationTable}}</div>
                          <div class="small">{{scope.row.brojSasije}}</div>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="filterSelected !== 'terms'"
                      sortable
                      :class-name="setColumnClass('driver')"
                      align="center"
                      :sort-method="(a, b) => sortData(a, b, 'korisnikPrezimeIme')"
                      :label='$t( "myFleet.driver")'
                      prop="korisnikPrezimeIme">
                      <template slot-scope="scope">
                          <div>{{scope.row.korisnikPrezimeIme}}</div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      sortable
                      :class-name="setColumnClass('contractOptions')"
                      align="center"
                      :sort-method="(a, b) => sortData(a, b, 'ugpDuration')"
                      :label='$t( "myFleet.contractOptions")'
                      prop="ugovorenaKilometraza">
                      <template slot-scope="scope">
                          <div class="font-weight-bold">{{scope.row.ugpDuration}} <span class="small">MJ</span></div>
                          <div class="font-weight-bold">{{formatMileage(scope.row.ugovorenaKilometraza)}} <span class="small">KM</span></div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      sortable
                      :class-name="setColumnClass('contractExpiringMileage')"
                      align="center"
                      :sort-method="(a, b) => sortData(a, b, 'serviceEnd_raw')"
                      :formatter="(r, c, val, i) => formatDatePlusLeftover(r)"
                      :label='$t( "myFleet.contractEndPlusMileage")'
                      prop="serviceEnd_raw">
                      <template slot-scope="scope">
                          <div>{{formatDatePlusLeftover(scope.row)}}</div>
                          <div>{{formatMileage(scope.row.lastDocumentedMileage) || '-'}} <span class="small">KM</span></div>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="filterSelected === 'terms'"
                      sortable
                      :class-name="setColumnClass('registrationEnd')"
                      align="center"
                      :sort-method="(a, b) => sortData(a, b, 'registrationEndDate_raw')"
                      :formatter="(r, c, val, i) => formatDatePlusLeftover(r, 'registrationEndDate_raw')"
                      :label='$t( "myFleet.registrationEndDate")'
                      prop="registrationEndDate_raw">
                      <template slot-scope="scope">
                          <div>{{formatDatePlusLeftover(scope.row, 'registrationEndDate_raw')}}</div>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="filterSelected === 'terms'"
                      sortable
                      :class-name="setColumnClass('insuranceEnd')"
                      align="center"
                      :sort-method="(a, b) => sortData(a, b, 'istekOsig_raw')"
                      :formatter="(r, c, val, i) => formatDatePlusLeftover(r, 'istekOsig_raw')"
                      :label='$t( "myFleet.insuranceEndDate")'
                      prop="istekOsig_raw">
                      <template slot-scope="scope">
                          <div>{{formatDatePlusLeftover(scope.row, 'istekOsig_raw')}}</div>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="filterSelected === 'terms'"
                      sortable
                      :class-name="setColumnClass('osigkEnd')"
                      align="center"
                      :sort-method="(a, b) => sortData(a, b, 'istekOsigk_raw')"
                      :formatter="(r, c, val, i) => formatDatePlusLeftover(r, 'istekOsigk_raw')"
                      :label='$t( "myFleet.kaskoInsuranceEndDate")'
                      prop="istekOsigk_raw">
                      <template slot-scope="scope">
                          <div>{{formatDatePlusLeftover(scope.row, 'istekOsigk_raw')}}</div>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="filterSelected !== 'terms'"
                      sortable
                      align="right"
                      :sort-method="(a, b) => sortData(a, b, 'contractMonthlyAmount')"
                      :label='$t( "myFleet.contractMonthlyAmount")'
                      :formatter="(r, c, val, i) => formatMileage(val)"
                      prop="contractMonthlyAmount">
                      <template slot-scope="scope">
                          <div>{{formatMoney(scope.row.monthlyAmount) || '-'}} <span class="small">{{scope.row.monthlyAmountCurency}}</span></div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      align="center"
                      :label='$t( "myFleet.status")'
                      prop="">
                      <template slot-scope="scope">
                          <div class="table-action-rows">
                            <div class="contract-expiring" v-if="scope.row.contractExpiring"></div>
                            <div class="contract-missing" v-if="scope.row.mileageMissing"></div>
                            <div class="contract-ticketInProgress" v-if="scope.row.ticketInProgress"></div>
                          </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      width="80px"
                      align="center">
                      <template slot-scope="scope">
                        <p-button class="action-button" aria-label="add button" type="default" round icon size="sm" :style="{ backgroundImage: `url(static/img/icons/button-${contractSelected.includes(scope.row.idFlat) ? 'active' : 'action'}.png)` }" @click="rowClicked(scope.row)"></p-button>
                      </template>
                    </el-table-column>
                </el-table>
                </div>
            </div>
            </div>
        </div>
        <modal :show.sync="createTicketModalActive"
            footer-classes="justify-content-center"
            class="create-ticket-modal"
            type="notice"
            v-on:close="onModalClose"
        >
            <h5 slot="header" class="modal-title">{{ $t( "myFleet.newTicket") }}</h5>

            <template>
                <form class="form-horizontal">
                    <div class="row">
                        <label class="col-md-3 col-form-label">{{ $t( "myFleet.car") }}</label>
                        <div class="col-md-9">
                            <fg-input>
                                <el-select class="select-default"
                                            size="large"
                                            filterable
                                            :placeholder='$t( "myFleet.pickVehicle")'
                                            :clearable="true"
                                            :loading-text='$t( "myFleet.sendingRequest")'
                                            v-model="vehicleSelectedTicket"
                                            >
                                    <el-option v-for="option in contracts"
                                            class="select-default"
                                            :value="option.auto._id"
                                            :label="`${option.auto.autoManufacturer || ''} ${option.auto.modelAndManufacturer}`"
                                            :key="option._id">
                                            <span style="float: left">
                                              <strong>{{`${option.auto.autoManufacturer || ''}`}}</strong> {{`${option.auto.modelAndManufacturer || ''}`}}
                                            </span>
                                    </el-option>
                                </el-select>
                            </fg-input>
                            <div v-if="vehicleSelectedTicket">
                              <div class="input selected-vehicle-registration">{{getSelectedVehicleInfo().registracijskeTablice}}</div>
                              <div class="input description">{{getSelectedVehicleInfo().brojSasije}}</div>
                            </div>
                        </div>
                        <hr class="w-100">

                        <label class="col-md-3 col-form-label">{{ $t( "myFleet.ticketType") }}</label>
                        <div class="col-md-9">
                            <p-radio
                                v-for="(key, value) in ticketTypes"
                                :key="key"
                                :value="key"
                                :label= value
                                v-model = newTicketData.ticketType
                            >{{key}}</p-radio>
                        </div>
                        <hr class="w-100">
                        <label class="col-md-3 col-form-label" v-if="(newTicketData.ticketType !== 'inquiry') && (newTicketData.ticketType !== 'extendRegistration')">{{ $t( "myFleet.location") }}</label>
                        <div class="col-md-9" v-if="(newTicketData.ticketType !== 'inquiry') && (newTicketData.ticketType !== 'extendRegistration')">
                            <fg-input>
                                <el-select class="select-default"
                                            size="large"
                                            filterable
                                            :placeholder='$t( "myFleet.pickLocation")'
                                            :clearable="true"
                                            :loading-text='$t( "myFleet.sendingRequest")'
                                            v-model="newTicketData.lokacijaKoristenja"
                                            >
                                    <el-option v-for="option in locations"
                                            class="select-default"
                                            :value="option.value"
                                            :label="option.name"
                                            :key="option.value">
                                            <span style="float: left"><i class="fa fa-map-marker-alt"></i> {{option.name}}</span>
                                    </el-option>
                                </el-select>
                            </fg-input>
                        </div>
                        <hr class="w-100">
                        <label class="col-md-3 col-form-label">{{ $t( "myFleet.suggestServiceDate") }}</label>
                        <div class="col-md-9">
                            <div class="form-group">
                                <el-date-picker
                                    v-model="newTicketData.vehicleToServiceDesiredDate"
                                    type="datetime"
                                    :placeholder='$t( "myFleet.selectDateAndTime")'
                                    :minDate="datePickerOptions.minDate"
                                    :format="datePickerOptions.format"
                                    :disabledDate="datePickerOptions.disabledDate"
                                    :pickerOptions="datePickerOptions.options"
                                    >
                                </el-date-picker>
                            </div>
                        </div>
                        <hr class="w-100">
                        <label class="col-md-3 col-form-label">{{ $t( "contacts.note") }}</label>
                        <div class="col-md-9">
                            <textarea class="form-control" v-model="newTicketData.description" :placeholder='$t( "myFleet.typeDescription")' rows="3"></textarea>
                        </div>

                    </div>
                </form>
            </template>
            <div slot="footer" class="justify-content-center">
                <el-button class="custom-button" type="warning" round @click.native="createTicket" :disabled="apiInProgress" :loading="apiInProgress">{{ $t( "myFleet.newTicket") }}</el-button>
            </div>
        </modal>
        <new-mileage :newMileageModalActive.sync="newMileageModalActive" :vehicleSelected.sync="vehicleSelected" :apiInProgress.sync="apiInProgress"></new-mileage>
    </div>
</template>
<script>

  import Vue from 'vue'
  import moment from 'moment'
  //import JsonExcel from 'vue-json-excel'
  import JsonExcel from 'src/components/UIComponents/xlsExport.vue'
  import locations from 'src/util/locations.js'

  import Card from 'src/components/UIComponents/Cards/Card';
  import Badge from 'src/components/UIComponents/Badge';
  import {Modal, NewMileage, TicketActivities, Tabs, TabPane} from 'src/components/UIComponents';

  import alerts from 'src/util/alerts.js'

  import swal from 'sweetalert2';
  import {IMaskDirective} from 'vue-imask';

  import {Table, TableColumn, Input, Button, Select, Option, DatePicker, RadioButton, RadioGroup} from 'element-ui'
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Input)
  Vue.use(Button)

  Vue.component('downloadExcel', JsonExcel)

  let minDate = moment().add((moment().day() === 4 || moment().day() === 5) ? 5:3, 'days').hour(8).minutes(0).seconds(0);

  export default {
    components: {
        Tabs,
        TabPane,
        Card,
        [Badge.name]: Badge,
        [Option.name]: Option,
        [Select.name]: Select,
        [RadioButton.name]: RadioButton,
        [RadioGroup.name]: RadioGroup,
        Modal,
        TicketActivities,
        [DatePicker.name]: DatePicker,
        [NewMileage.name]: NewMileage,
        [TicketActivities.name]: TicketActivities
    },

    data () {

      locations[0].name = this.$t('myFleet.chooseLocation');

      return {
        search: '',
        apiInProgress: false,
        createTicketModalActive: false,
        newMileageModalActive: false,
        vehicleSelected: '',
        vehicleSelectedTicket: '',
        statuses: {
          new: {
            color: 'success',
            label: this.$t('ticketStatuses.new')
          },
          in_progress: {
            color: 'warning',
            label: this.$t('ticketStatuses.inProgress')
          },
          resolved: {
            color: 'secondary',
            label: this.$t('ticketStatuses.resolved')
          },
        },
        json_fields: {
            'Model': 'model',
            'Registration plates': 'registrationTable',
            'Driver': 'korisnikPrezimeIme',
            'Contract start' : {
                field: 'serviceStart',
                callback: (value) => {
                    return `${value}`;
                }
            },
            'Contract end': 'serviceEnd',
        },
        driverChangeInProgress: false,
        locations: locations,
        newTicketData: {
            ticketType: 'servis',
            description: '',
            lokacijaKoristenja: '',
            vehicleToServiceDesiredDate: minDate
        },
        datePickerOptions: {
          minDate: moment().add((moment().day() === 4 || moment().day() === 5) ? 5:3, 'days').startOf('day'),
          format: 'dd.MM.yyyy HH:mm',
          options: {
              disabledDate: function (date) {
                if ((moment(date).day() === 6) || (moment(date).day() === 0)) {
                    return true;
                }
                // disable past days
                return date.getTime() < minDate.valueOf() - 8.64e7
            },
            firstDayOfWeek: this.$t.locale === 'en' ? 7 : 1
          },
          timePickerPlaceholder: 'Izaberite vrijeme',
          headerPlaceholder: 'Izaberite datum',
          toolbarCloseText: 'OK'
        },
        ticketTypes: {
          servis: this.$t('ticketTypes.servis'),
          servis_izvanredni: this.$t('ticketTypes.servis_izvanredni'),
          servis_izvanredni_plus: this.$t('ticketTypes.servis_izvanredni_plus'),
          accident: this.$t('ticketTypes.accident'),
          extendRegistration: this.$t('ticketTypes.extendRegistration'),
          tires: this.$t('ticketTypes.tires'),
          inquiry: this.$t('ticketTypes.inquiry'),
        },
        filter: 'all',
        activeTicketItem: 'activeCases',
        ticketSelected: null
      }
    },
    mounted() {
        if (!this.$store.fleet.store.fleetData.loaded) this.$store.fleet.actions.getFleet();
        if (!this.$store.contacts.store.contacts.loaded) this.$store.contacts.actions.getContacts();

        this.filter = this.$store.fleet.store.fleetData.filterSelected;

        if (this.$store.fleet.store.fleetData.openNewTicket) {
          this.$store.fleet.store.fleetData.openNewTicket = false;
          this.openNewTicketModal(null);
        }
    },
    watch: {
        filterSelected(value) {
            console.log('filterSelected store change!', value);
            this.$refs.tableFleet.clearSort();
            this.filter = value;
            this.$store.fleet.store.fleetData.contractSelected = [];
        }
    },
    computed: {
        console: () => console,
        user: function() { return this.$store.user },
        fleetData: function() { return this.$store.fleet.store.fleetData },
        contracts: function() { return this.$store.fleet.store.fleetData.data.contracts },
        contractSelected: function() { return this.$store.fleet.store.fleetData.contractSelected },
        filterSelected: function() { return this.$store.fleet.store.fleetData.filterSelected },
        filterSelectedAdditional: function() { return this.$store.fleet.store.fleetData.filterSelectedAdditional },
        openNewTicket: function() { return this.$store.fleet.store.fleetData.openNewTicket },
        contacts: function() { return this.$store.contacts.mutations.getContactsFull() },
        fleetDataFlat: function() {
            let dataFiltered = this.$store.fleet.mutations.getFiltered(this.filterSelected);
            return dataFiltered.map( item => {
                return {
                    idFlat: item._id,
                    id: item.auto._id,
                    ugpId: item.najamId,
                    registrationTable: item.auto.registracijskeTablice,
                    brojSasije: item.auto.brojSasije,
                    model: `${item.auto.autoManufacturer || '-'} ${item.auto.modelAndManufacturer || '-'}`,
                    manufacturer: `${item.auto.autoManufacturer || '-'}`,
                    modelAndManufacturer: `${item.auto.modelAndManufacturer || '-'}`,
                    registrationDate: this.formatDate(item.auto.registrationDate),
                    registrationEndDate: this.formatDate(item.auto.registrationEndDate),
                    registrationEndDate_raw: item.auto.registrationEndDate,
                    leasingDuration: item.auto.leasingDuration,
                    leasingExpireDate: item.auto.leasingExpireDate,
                    leasingExpireDate: item.auto.leasingExpireDate,
                    osigoBrojPolice: item.auto.osigoBrojPolice,
                    pocetakOsigo: item.auto.pocetakOsigo,
                    istekOsig: this.formatDate(item.auto.istekOsig),
                    istekOsig_raw: item.auto.istekOsig,
                    pocetakOsigk: item.auto.pocetakOsigk,
                    istekOsigk: this.formatDate(item.auto.istekOsigk),
                    istekOsigk_raw: item.auto.istekOsigk,
                    korisnikPrezimeIme: item.auto.korisnikPrezimeIme,
                    korisnikId: item.auto.korisnik,

                    serviceType: item.najam.ServiceType,
                    ugovorenaKilometraza: item.najam.ugovorenaKilometraza,
                    ugpDuration: item.najam.ugpDuration,
                    serviceStart: this.formatDate(item.najam._start),
                    serviceStart_raw: item.najam._start,
                    serviceEnd: this.formatDate(item.najam._end),
                    serviceEnd_raw: item.najam._end,
                    overallMonthlyCostForClient: item.najam.overallMonthlyCostForClient,
                    carPhoto: item.carPhoto,
                    monthlyAmount: item.monthlyInvoiceAmount,
                    monthlyAmountCurency: item.monthlyInvoiceAmountCurency,

                    lastDocumentedMileage: item.mileage && item.mileage.lastDocumentedMileage && item.mileage.lastDocumentedMileage.km,
                    projectedTodayMileage: item.mileage && item.mileage.projectedTodayMileage,
                    projectedFinalMileage: item.mileage && item.mileage.projectedFinalMileage,
                    lastDocumentedMileageDate: this.formatDate(item.mileage && item.mileage.lastDocumentedMileage && item.mileage.lastDocumentedMileage.mileageDate.sec * 1000),
                    differenceInTheEndOfContract: this.getDifferenceMileage(item.mileage || {}, item.najam.ugovorenaKilometraza),

                    tickets: item.tickets,

                    contractExpiring: item.contractExpiring,
                    mileageMissing: item.mileageMissing,
                    ticketInProgress: item.ticketInProgress,
                    isActive: item.active

                }
            })
      }
    },

    methods: {
        getUgpEventsHistory: function( ugpId ) { return this.fleetData.eventsHistory[ ugpId ] || [] },

        refreshData() {
            this.$store.fleet.actions.getFleet();
        },
        downloadFleetXls() {
            this.$store.fleet.actions.downloadFleetXls();
        },
        filterSearch() {
            let that = this;
            if (!that.search) return that.fleetDataFlat;
            return that.fleetDataFlat.filter(data => {
                let bingo = false;
                Object.values(data).forEach(prop => {
                    if ( prop && prop.toString().toLowerCase().includes(that.search.toLowerCase())) {
                    bingo = true;
                    }
                });
                return bingo;
            })
        },
        sortData(a, b, key) {
            const dates = ['serviceStart_raw', 'serviceEnd_raw', 'registrationEndDate_raw', 'istekOsig_raw', 'istekOsigk_raw'];
            const numbers = ['differenceInTheEndOfContract', 'ugovorenaKilometraza', 'overallMonthlyCostForClient'];
            if (dates.includes(key)) {
              return moment(a[key]).isBefore(moment(b[key])) ? 1 : -1
            }
            if (numbers.includes(key)) {
            try {
                a[key] = JSON.parse(a[key]);
                b[key] = JSON.parse(b[key]);
            }
            catch(err) {}
            if (typeof(a[key]) === 'string' )  return -1;
            else if (typeof(b[key]) === 'string' ) return 1;
            }
            //console.log([a[key], b[key]], a[key] > b[key] ? 1 : a[key] < b[key] ? -1 : 0);
            return a[key] > b[key] ? 1 : a[key] < b[key] ? -1 : 0
        },
        formatDate(date) {
            if (!date || date === '-') return '-';
            let dateM = moment(date);
            if (!dateM.isValid()) {
              dateM = moment(date, 'DD.MM.YYYY');
              if (!dateM.isValid()) {
                console.log('invalid date!', date);
                return '-';
              }
            }
            return dateM.format('DD.MM.YYYY');
        },
        formatMileage(mileage) {
            if (!mileage || mileage === 'null' || mileage === '-') return '-';
            mileage = Math.round(mileage);
            mileage = mileage.toString();
            if (mileage !== '' || mileage !== undefined || mileage !== 0  || mileage !== '0' || mileage !== null) {
            return mileage.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            }
            return mileage
        },
        formatMoney(x = '-') {
            var parts = x.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            return parts.join(",");
            //return x.toLocaleString();
        },
        formatDatePlusLeftover(row, prop = 'serviceEnd_raw') {
            let date = this.formatDate(row[prop]);
            let days = this.calculateTimeLeft(row[prop]);

            return date + (days ? days : '');
        },
        daysLeftBeforeTerm(row, prop = 'serviceEnd_raw') {
            let days = this.calculateTimeLeft(row[prop], true);
            if (days > 89) return 'success'
            else if (days > 29) return 'warning'
            else return 'danger'

        },
        getDifferenceInDays(date) {
            let oneDay = 24*60*60*1000;
            let expires = new Date(date);
            let today = new Date();
            return Math.round((expires.getTime() - today.getTime())/(oneDay));
        },
        calculateTimeLeft(date, justDays = false) {
            if (!date) return;
            let diffDays = this.getDifferenceInDays(date);
            let sufixDays = '';
            switch (diffDays) {
            case 0:
                sufixDays = this.$t('general.today');
                break;
            case 1:
                sufixDays = this.$t('general.day');
                break;
            default:
                sufixDays = this.$t('general.days');

            if (justDays) return diffDays;
            return diffDays ? ` (${diffDays} ${sufixDays})` : `(${sufixDays})`;
            }
        },
        getDifferenceMileage({projectedFinalMileage, ugpStartMileage}, ugovorenoKm, formatMileage) {
            if (!projectedFinalMileage || !ugovorenoKm || !ugpStartMileage || !ugpStartMileage.km) return '-';

            let diff = projectedFinalMileage - (JSON.parse(ugovorenoKm) + ugpStartMileage.km);
            if (!formatMileage) return diff
            return this.formatMileage(diff);
        },
        colorMileageDiff(mileage) {
            if (!mileage || mileage === 'null' || mileage === '-') return '';
            if (mileage < 0) return 'green';
            return 'red'
        },

        rowClicked(row) {
            console.log("clicked! ugpId:", row.ugpId );
            
            if (this.contractSelected.includes(row.idFlat)) {
              return this.$store.fleet.store.fleetData.contractSelected = this.$store.fleet.store.fleetData.contractSelected.filter(e => e !== row.idFlat);
            }
            
            this.$store.fleet.store.fleetData.contractSelected.push(row.idFlat);

            this.getVehicleEventsHistory( row );

        },

        tableRowClassName(row) {
            if (!row.row.isActive) return 'not-active';
            else {
              let indexNum = this.fleetDataFlat.findIndex( vehicle => vehicle.idFlat === row.row.idFlat);
              if (!this.fleetDataFlat[indexNum + 1]) return;
              if (!this.fleetDataFlat[indexNum + 1].isActive) return 'last-active'
            }
        },
        async onDriverChange(i, newValue) {
            this.driverChangeInProgress = true;
            this.apiInProgress = true;
            let respError = await this.$store.fleet.actions.modify(this.fleetDataFlat[i].id, {korisnik: newValue}).catch( (err) => { console.error('problemi;', err); respError = err;});
            this.driverChangeInProgress = false;
            this.apiInProgress = false;
            if (respError) {
                console.log('respError', respError);
                return;
            }

            swal({
                title: this.$t('myFleet.driverInfoSave'),
                type: 'success',
                timer: 2000,
                showConfirmButton: false
            }).catch(err => {});

            this.fleetData.data.contracts[i].auto.korisnik = newValue;

            if (!newValue) return this.fleetData.data.contracts[i].auto.korisnikPrezimeIme = '';

            let contactObject = this.contacts.find( ({ _id }) => _id === newValue);
            this.fleetData.data.contracts[i].auto.korisnikPrezimeIme = `${contactObject.firstName} ${contactObject.lastName}`;


        },
        openNewTicketModal(vehicleId) {
            this.createTicketModalActive = true;
            this.vehicleSelectedTicket = vehicleId;
		    },
        openNewMileageModal(vehicleId) {
            this.vehicleSelected = vehicleId;
            this.newMileageModalActive = true;
		    },
        onModalClose() {
            this.errors.clear();
        },

        async getVehicleEventsHistory( rowData ) {
            console.log("getVehicleEventsHistory api client side", rowData.ugpId )
            console.log("this.fleetData.data", this.fleetData);
            
            let existingEvents = this.fleetData.eventsHistory[ rowData.ugpId ];

            if ( existingEvents ) {
              return;
            }
            
            let ugpId = rowData.ugpId;
            this.apiInProgress = true;
            let eventsHistory = await this.$store.fleet.actions.getVehicleEventsHistory(ugpId).catch( (err) => { console.error('problemi;', err); respError = err;});
            this.apiInProgress = false;
            console.log("GOT EVENTS!", eventsHistory.events );

            this.fleetData.eventsHistory[ rowData.ugpId ] = eventsHistory.events;

        },

        async createTicket() {
            this.newTicketData.vehicleToServiceDesiredDate = moment(this.newTicketData.vehicleToServiceDesiredDate).toISOString();
            let vehicleId = this.vehicleSelectedTicket;

            if (!vehicleId) return;
            //this.driverChangeInProgress = true;
            this.apiInProgress = true;
            let newTicket = await this.$store.fleet.actions.createTicket(this.newTicketData, vehicleId).catch( (err) => { console.error('problemi;', err); respError = err;});
            //this.driverChangeInProgress = false;
            this.apiInProgress = false;
            if (newTicket.status !== "success") {
                console.log('respError', newTicket);
                return alerts.error(newTicket.info ? newTicket.info.message : '');
            }

            let contractObject = this.fleetData.data.contracts.find( ({ auto }) => auto._id === this.vehicleSelectedTicket);

            if (contractObject) contractObject.tickets.unshift(newTicket.ticket);
            document.getElementsByClassName('nc-simple-remove')[0].click();

            this.newTicketData = {
                ticketType: 'servis',
                description: '',
                lokacijaKoristenja: '',
                vehicleToServiceDesiredDate: minDate
            },

            swal({
                title: this.$t('myFleet.newTicketOpened'),
                type: 'success',
                timer: 2000,
                showConfirmButton: false
            }).catch(err => {});
        },

        filterChanged(val) {
            this.fleetData.filterSelected = val;
        },

        filterChanged2(val) {
            if (val.target.value && val.target.value === this.fleetData.filterSelected) {
              this.fleetData.filterSelected = 'all';
              this.fleetData.filterSelectedAdditional = '';
            }
        },
        isActiveTicketTab (menuItem) {
          return this.activeTicketItem === menuItem
        },
        setActiveTicketsTab (menuItem) {
          this.activeTicketItem = menuItem
        },
        getSelectedVehicleInfo() {
          let vehicle = this.contracts.find( contract => contract.auto._id === this.vehicleSelectedTicket);
          if (vehicle) return vehicle.auto;
          return {};
        },
        ticketShow(ticket) {
          console.log('ticketShow', ticket);
          if (this.ticketSelected && this.ticketSelected._id === ticket._id) return this.ticketSelected = null;
          this.ticketSelected = ticket;
        },
        getTickets(tickets, notClosed) {
            let filtered;
            let ticketSelected;
            if (this.ticketSelected) ticketSelected = tickets.filter(ticket => ticket._id === this.ticketSelected._id);
            if (ticketSelected && ticketSelected.length) return ticketSelected;
            
            //if (notClosed) filtered = tickets.filter(ticket => ticket.metadata.status !== 'resolved');
            //else filtered = tickets.filter(ticket => ticket.metadata.status === 'resolved');

            return tickets;
        },
        setColumnClass(column) {
          if (this.filterSelected === 'all') return;

          if (this.filterSelected === 'contractExpiring' && ['model', 'contractOptions', 'contractExpiringMileage'].includes(column)) return `active-filter-${this.filterSelected}`;
          if (this.filterSelected === 'mileageMissing' && ['model', 'contractExpiringMileage'].includes(column)) return `active-filter-${this.filterSelected}`;
          if (this.filterSelected === 'ticketInProgress' && ['model', 'driver', 'sasija'].includes(column)) return `active-filter-${this.filterSelected}`;
          if (this.filterSelected === 'terms' && ['model', 'contractExpiringMileage', 'registrationEnd', 'insuranceEnd', 'osigkEnd'].includes(column)) return `active-filter-${this.filterSelected}`;
        }


    },
    directives: {
        imask: IMaskDirective
    }
  }

</script>
<style scoped>

  .fleet-table-card {
    background-color: #e3e3e3;
  }
  ::v-deep .card {
    background-color: transparent;
    box-shadow: unset;
  }
  .action-buttons-col button, .new-ticket-btn {
    float:right;
  }
  .action-buttons-col i, .new-ticket-btn i {
	font-size: 1.5em;
  }
  .spinner-container {
    position:fixed;
    right: 45%;
    top: 8%;
  }
  .text-search {
    width: 20%;
    margin-left: 45%;
  }
  ::v-deep .text-search input {
    border-radius: 25px 0px 0px 25px;
  }
  ::v-deep .text-search .input-group-append span {
    border-radius: 0px 25px 25px 0px;
  }
  .card-title {
    margin-bottom: 1.75rem;
    margin-top: 0px;
  }
  .green {
    color:green;
  }
  .red {
    color:red;
  }
  .no-margin-bottom {
    margin-bottom: unset;
  }
  .card-text {
    font-weight: bold;
    font-size: 1.2em;
  }
  .card-subtitle {
    font-style: oblique;
    font-size: 0.8em;
  }
  .single-card {
    font-weight: 700;
    text-transform: uppercase;
    margin-right: 2%;
    margin-left: 1%;
  }
  .ticket-status-badge{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 1.2em;
  }
  ::v-deep .table-expandable tbody .el-table__row:not(.not-active) {
    background-color: white !important
  }
  ::v-deep .table-expandable tbody:first-of-type .el-table__row td:first-child .cell {
    visibility: hidden !important;
  }
  ::v-deep .fleet-tickets-table tbody:first-of-type .el-table__row td:first-child .cell {
    visibility: visible !important;
  }
  ::v-deep .table-expandable tbody:first-of-type .el-table__row {
    cursor: zoom-in;
  }
  ::v-deep .table-expandable tbody:first-of-type .el-table__row.expanded {
    cursor: zoom-out;
  }
  
  ::v-deep .table-expandable tbody .el-table__row.expanded td {
    border-top: 2px solid black;
  }
  ::v-deep .table-expandable .el-table__expanded-cell {
    cursor: default;
    background-color: #eee !important;
    border-bottom: 2px solid black;
  }

  /* fleet-tickets-table table */
  ::v-deep .fleet-tickets-table .el-table__row {
    cursor: auto !important;
  }
  ::v-deep .fleet-tickets-table table thead th div{
    text-overflow: clip !important;
    font-size: 0.8em;
    font-weight: bold;
    padding: 0px;
  }
  ::v-deep .fleet-tickets-table table tbody tr{
    text-overflow: clip !important;
    font-size: 0.8em;
    font-weight: bold;
    padding: 0px;
  }
  ::v-deep .fleet-tickets-table-badge {
    padding: 0px !important;
  }
  ::v-deep .fleet-tickets-table-badge div {
    padding: 0px !important;
    text-overflow: clip !important;
    text-align: center !important;
  }
  ::v-deep .fleet-tickets-table-badge div span {
    padding: 0px !important;
  }
  ::v-deep .fleet-tickets-table-expanded {
    padding-left: 25px;
    padding-right: 35px;
  }
  /* fleet-tickets-table table end */

  ::v-deep .el-table .kn-row {
    color: darkorange;
  }
  .el-select-dropdown__item.is-disabled:hover {
      background-color: #66615B !important;
  }
  .vehicle-driver-label {
      font-size: 1em;
      color: black
  }
  textarea {
      padding: 10px;
  }
  ::v-deep .el-picker-panel__footer .el-button--text.el-button--mini {
      display: none;
  }

  .mileage-span-plus {
      font-size: 1.6em;
  }

  .new-mileage-btn {
    padding: 8px;
    float: right;
  }

  /* filters */
  ::v-deep .fleet-filter-container .el-radio-button__inner:hover  {
    color: #d6752d;
  }
  ::v-deep .fleet-filter-container label  {
    margin-right: 10px;
  }
  ::v-deep .el-radio-button__inner  {
   white-space: normal !important;
  }
  ::v-deep .fleet-filter-container label span, ::v-deep .fleet-filter-container label:first-of-type span {
    border-radius: 15px !important;
    border: 5px solid #c5c5c5;
    border-radius: 4px 0 0 4px;
    -webkit-box-shadow: none!important;
    box-shadow: none!important;
    max-height: 100px;
    min-height: 100px;
    max-width: 150px;
    min-width: 150px;
  }
  ::v-deep .fleet-filter-container label.is-active:nth-of-type(1) span {
    background-color: #efdec6;
    border: 5px solid#d6752d;
    color:black;

  }
  .fleet-filter-container label:nth-of-type(1) .radio-button-up {
    color:#d6752d;
  }
  ::v-deep .fleet-filter-container label.is-active:nth-of-type(2) span {
    background-color: rgb(189, 187, 187);
    border: 5px solid gray;
    color:black;
  }
  .fleet-filter-container label:nth-of-type(2) .radio-button-up {
      color: gray;
  }
  ::v-deep .fleet-filter-container label.is-active:nth-of-type(3) span {
    background-color: rgb(186, 211, 248);
    border: 5px solid rgb(28, 63, 116);
    color:black;
  }
  .fleet-filter-container label:nth-of-type(3) .radio-button-up {
      color: rgb(28, 63, 116);
  }
  ::v-deep .fleet-filter-container label.is-active:nth-of-type(4) span {
    background-color: rgb(216, 96, 96);
    border: 5px solid rgb(85, 0, 0);
    color:black;
  }
  .fleet-filter-container label:nth-of-type(4) .radio-button-up {
      color: rgb(85, 0, 0);
  }
  .radio-button-up {
    display: flex;
    justify-content: left;
    align-items: left;
    font-size: 2em;
    font-weight: bold;
    margin-bottom: 10px;
    margin-left: unset;
  }

  .radio-button-down {
    align-items: left;
    display: inline;
    margin-right: unset;
    margin-left: unset;
    font-weight: bold;
    /* word-wrap: break-word;
    word-break: break-all; */
  }
  /* filters end */

  .myFleet-number {
    font-size: 3em;
    font-style: italic;
  }

  ::v-deep .el-table .not-active {
    opacity: 0.6;
    
  }
  ::v-deep .table-expandable .not-active.expanded + tr {
    opacity: 0.6;
    
  }
  ::v-deep .el-table .el-table__body-wrapper tr:not(.not-active) .active-filter-contractExpiring {
    color: #d6752d;
  }
  ::v-deep .el-table .el-table__body-wrapper tr:not(.not-active) .active-filter-mileageMissing {
    color: darkgray;
  }
  ::v-deep .el-table .el-table__body-wrapper tr:not(.not-active) .active-filter-ticketInProgress {
    color: rgb(28, 63, 116);
  }
  ::v-deep .el-table .el-table__body-wrapper tr:not(.not-active) .active-filter-terms {
    color: rgb(85, 0, 0);
  }
  ::v-deep .el-table .last-active:not(.expanded) td {
    border-bottom: 2px solid#d6752d;
  }
  ::v-deep .el-table .table-row-number {
    font-size: 1.4em;
    padding-top: 6%;
    padding-right: unset;
  }

  ::v-deep .el-table table thead th div{
    text-overflow: clip !important;
    font-size: 0.8em;
    font-weight: bold;
    padding: 0px;
  }

  .contract-expiring {
    width: 8px;
    height: 30px;
    background-color:#d6752d;
    border-radius: 25px;
  }
  .contract-missing {
    width: 8px;
    height: 30px;
    background-color: gray;
    border-radius: 25px;
  }
  .contract-ticketInProgress {
    width: 8px;
    height: 30px;
    background-color: rgb(28, 63, 116);
    border-radius: 25px;
  }

  .table-action-rows {
    display: flex;
    margin-left: 40%;
  }
  .table-action-rows div {
    margin-right: 5px;
  }
  .action-button {
    background-color: lightgray;
    color: black;
    background-position: center;
    border: 2px solid lightgray;
    background-size: cover;
  }

  /* cards in expanded table row */


  .fleet-contract-details>div:not(:first-child) {
    border-left: 1px solid gray
  }

  .vehicle-image-big {
    max-height: 19em;
    min-height: 19em;
  }

  .fleet-card {
    margin-top: 3em;
    background-color: white;
    border-radius: 4px;
    padding: 16px;
    max-height: 28em;
    min-height: 28em;
  }

  .fleet-card .fleet-date-stick {
    width: 8px;
    height: 40px;
    background-color:#d6752d;
    border-radius: 15px;
  }
  .fleet-card .fleet-date-stick-success {
    background-color: green;
  }
  .fleet-card .fleet-date-stick-warning {
    background-color:#d6752d;
  }
  .fleet-card .fleet-date-stick-danger {
    background-color: red;
  }
  .fleet-card .fleet-card-middle {
    margin-bottom: 10px;;
  }
  .fleet-card .action-icon {
    margin-top: 10px;
    margin-left: -10px;
    font-size: 1.3em;
    color: gray;
    font-weight: bold;
  }

  .fleet-card2 {
    border-top: 1px solid brown;
    margin-right: 10px;
    background-color: white;
    border-radius: 4px;
    max-height: 28em;
    min-height: 28em;
    overflow: scroll;
  }

  .tickets-container .tickets-tab-active {
    font-weight: bold;
    color: brown;;
  }
  .tickets-container .tickets-tab-active .badge {
    font-weight: bold;
    background-color: brown;
  }

  .tickets-container .nav-item.nav-item-cases, 
  .tickets-container .nav-item.nav-item-historycases {
    border-right: 1px solid gray;
  }

  .nav-item .badge {
    position: relative;
    top: -3px;
    border-radius: 45px;
    padding: 4px 6px;
    margin-left: 3px;
    background-color: #777;
    color: white;
  }

  ::v-deep .tickets-container  .el-table__expanded-cell {
    background-color: #ffffff !important;
  }

  .add-ticket-btn {
    margin-left: 73% !important;
    margin-top: 10px !important;
    background-color:#d6752d;
  }
  .add-ticket-btn-top {
    /* margin-top: 5% !important;
    margin-right: 24px; */
    background-color:#d6752d;
  }

  .selected-vehicle-registration {
    width: fit-content;
    border-left: 3px solid gray;
    border-right: 3px solid gray;
    padding: 2px 6px 2px 6px;
  }

  ::v-deep .create-ticket-modal .modal-content {
    border: 3px solid#d6752d;
    border-radius: 20px;
  }
  ::v-deep .create-ticket-modal .modal-content input, .create-ticket-modal .modal-content textarea{
    border-radius: 20px;
    border-color: lightgray !important;
    border-width: 1px;
  }
  .ticket-activities {
    margin:  0px 18px 0px 18px;
  }
  
  .ticket-description {
    color: #222;
    padding: 4px 12px;
    border-bottom: 1px dashed grey;
  }

  ::v-deep .fleet-events-table .el-table__expand-column { visibility: hidden; max-width: 1px !important;}
  ::v-deep .fleet-events-table tr td:first-of-type { visibility: hidden; max-width: 1px !important; }
  ::v-deep .fleet-events-table tr th:first-of-type { visibility: hidden; max-width: 1px !important; }

  ::v-deep .fleet-events-table td { cursor: default; }

  .icon {
    display: inline-block; 
    width: 15px;
    height: 15px;
  }
  .reg-icon {
    background-size: 15px;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAB8klEQVRIS+WVTShmURjHX8pMCiuaIlZsWFigNBTKRCZCjXytSE3NwkKNyQYLJTNNmhqWBimhSJrkoykfsZekdzFTM7OwnUYZMeP3r+fW2+Wd9z03O6d+PffjPM//nP+559yEUCj0D1zbJQkvYDVWYoIJbBFFPG2UTtdGK3H5f0mewDCdhuKpbgN6SyyCCuiCmWi5QQU0oDGzqJLYDdN3iQQV2KfYHqTAS5tV0n0KRKt163mQGfiLaO0GQbUegIDrppMtThb1x7kX1C0RPptAI7EdDuBbZI2gi/yMIhOQ6xvQX+4XoRfO9M4v4GLRV/LfgY6YK8gGbbgO+AHVEPYLxLKoiqQa2IBmOL/D0gabxQmxxMUieX4Mj6AQfvuKJ3M/ACPQAx8Ug1j0ikT5/9gE/hBVXEe3bFkBHeU/NSAXiypJqIUC+A5rJqAjWwtbZrN6TtyBJahysUjro39BDmTCFxv5L2IaXEATrJvwFLHVRUDf+ZzZsE0sB+2DVBt5HXHXiivoxM1wEXhCgnydh04rJJEFaAEd317L5+IIJl0ElDwLmkm9jV7PZI9s8pq+MtlXDAWuAukkHUIWvIaPoN3rtTwuPsFT6IP3noD3h4roG/VSi9xmb2WZcrUnVLzUBN8Qx9XHE4incKw+YTpsgjbYqdf5BnKVjrYgP/ymAAAAAElFTkSuQmCC);
  }
  .odrz-icon {
    background-size: 15px;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACo0lEQVRIS7WVT0hVQRTGuy8o2lRG5rJFJGSFQqiILYJKKqxFEUEELkTBwKUthEhoWYuKWhUUBUERZEWUpQU961WWbgQxskUmEkSGRf+I9/x9zxkZ59173/NBFz7mnjPnfN/8OTMTLPrPX1Ak/2LytoFK8Ay8ieIpRqAWsstBEGwQaSaTuU2zvxCBNQT9At9jZrWFviTkywz5JzOTsXwCawnoAyXgnMGUl7QEexjy9Yb8H61mMxi3zHaJNLIBkrM20z5Gc8pLPEj3Tesjpof/XXHk6nP34A4E+4zAW9od4JslSCQSlyBttjaxV9PpdNNCBCogaSKpheQSyFQZDcAu1QP8cyOm/wN92ui/nkg19knQqeULqyIt12MjovXdCb4ifg3SIy4ZMVcYUBu+38avAdzAv5zYVv4vRpWpRvGIwJUEDvF/GNzC3ugvCf2T+AaAqrDW2ccK7JG4c6AK6SFhBSRp2kS+9bb9xPeamc/b5LD8RojvFUqsOMg/09SD7NmIm0Ep/X0IbC5UAPKXxB4CH21OlIDWszeOHLLXbLzKeRWYYLPv0z7VJNwBhQmIXCPfFDVyyP/QpxM9nm92vkCZIc+pFp8IEVWOLrkvwJZpjp4rIPInjFzlFfpBqqv5BOhWdSkI308aHaqzYUlWQPd7iiTVfxR5ko494AfYS+xdNxChDuzTfrIVyJajOTTbCWrAPmOD8ffzv9uQy11O/6hPRlw7vvOu3wocJeECAcN0VoE6bI1YS/DckPvvhE72AW8WupfWAb0T2S/nuobwPf7V5pp4wb/ul7BHaCl+iTR6InXYOg/zBGQcB132SkDoIbYOzbS/FI6tR+i6nQk5r7C3Aj1GOQJy6PqtAe9AKobY7dIq6O1QVela0RmZ+4p59AvUnQ2bAcy96BndKN7fAAAAAElFTkSuQmCC);
  }
  .upravljanje-stetama-icon {
    background-image: url(/static/img/icons/auto-damage-icon-128.png);
    background-size: 24px;
    display: inline-block; 
    width: 24px;
    height: 24px;
  }
  .pneu-icon {
    background-size: 15px;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAABEJAAARCQBQGfEVAAAAAd0SU1FB94FBg8PLy5+YfgAAAJhSURBVEjHndZLiI5hFAfw37iOWxhqXBPZYEFTrguRlFyi2FgQZWExRVkQKWTBwsLSAk2R+2VFUqSIFQu3IvfLGHK/NWO++WzOW4+395sPp56+8z7PuT3nOf9zPoqpFkNwGb9ifcZzXMMrtOImlqC3f6BpOINzeIJyONiKRryPvWx9wCVM/lsHc/AjlNvD0XzsTox25H7LeIgeeWNdc98b0IC+GIp72Ixh2Ig+IVcTRmsS3X6hdwWloshX565exm0sLYj8BNZjR0Se6iyrlJrZ+JoIHsdg7MkZb8xFXo8Hid7pIuOjIj1NSeQbMAItiXJTheBGJjJvIl1/0M6CNBzHpmT/C4Z3UhxpERxKD7pgX0FVTMex5PsUenbiYHQi+zQ13oF1OBu5bcMaXA9wZXQrwFWJPuJu8F9SB32iGmpj7xsWxv6C2GvDsyr4aU1k+sfSJWC+EvPienUYF2d1oVDCpyoOSsmNB2B85qAdzTnh5th/4/+pI3PwMRrWgXiDt9gVAo8TxPevYjAv8zNjeuEw3kWKWiMdfXE/qYwtVRwMwJ2QvZY+cgndArVldI9IpgRCM2qoUqYDMSH4J6mDtqj3+5GimmQm7I/OCnMjiEq0NuHL+cOaSFWG3IuYhalRGRkAD/5FqyhjZpHQ4wI0L4+WnW92Oml22ypdcRFe5iI5Gm/xoqBdr8P2pF1nZxM7q4R6rIpe0o69GJOkrqOgKab8+Uh1RRqER1FZ6U0ao7uWCkZmxh8pGpmVZsMKnExmwXcsDjC2FUy+Gxj7r1CfgQsBwB/x76EFV/E6Ir+FSQHKQvoN54zrbtG3ybEAAAAASUVORK5CYII=);
  }
  .zam-icon {
    background-size: 15px;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABn0lEQVRIS+2VzSsFURjGXXaSRL5ShIWSSMlCyYJQkr2FZOMfsMFKiZWklEhKkVigfFx3I8lCPlIkS8lGlFIUIX7PbUZjmhtzpmvl1K855z3neZ+Z8zWhBO8yQTgdLmP0O8OJNBphCJbc40MeCUqJDUPbL5LbQwqobEEZvDt1XgZzDBiDQx8GGjoD2yD9V3EbFNMzBfU+k2t4CSxCJXzYerfBOB0bEDYwkGQVpmHdyyCH4DLUGCaXrBpGoNbLYJDgBcwHMJB0F/pgTw1NkVa+CzrhFF4DGhSif4IVGJXBFeQHTBpLPikDe8WPqK9BO2hHmJQIogPohiwIOw1yCdxAFfg9A3qZW8iDN+iAWbeBEh+DTrC2m9/yiKAI7qAXdHV8+4J7Alr5Bkj2m90af83zDJogyTbQdOjt41EGtAZp0AwLlsMzz1YDt3I0OmQq59ADEfuqSKXxYHVqD6cYGNSh2bF0muroaf4zAxmdQAVsQovBF2Si0VWTAdpB/c4vUF3ToqtWB+XFwECSbNBW3YfoAfb64Rjm9pb9G/w4nXGfok+gNk0ZP3Hg8gAAAABJRU5ErkJggg==);
  }



</style>
